/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import {
  EuiListGroup,
  EuiListGroupItem,
  EuiPopover,
} from "@inscopix/ideas-eui";
import { CustomCellEditorProps } from "ag-grid-react";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";
import { useState } from "react";

const styles = {
  popover: css`
    & {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
    }
  `,
  panel: css`
    max-height: max(200px, 50vh);
    overflow-y: scroll;
  `,
};

export type CellEditorBooleanProps = CustomCellEditorProps<
  ParamsEditorRowDatum & {
    type: Extract<
      ParamsEditorRowDatum["type"],
      { param_type: "ToolBooleanParam" }
    >;
  }
>;

export const CellEditorBoolean = ({
  data,
  stopEditing,
  onValueChange,
}: CellEditorBooleanProps) => {
  const [value, setValue] = useState(data.type.default);

  return (
    <EuiPopover
      anchorPosition="downCenter"
      button={<span>{value}</span>}
      isOpen
      panelPaddingSize="none"
      css={styles.popover}
      closePopover={stopEditing}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          stopEditing(true);
        }
      }}
      display="block"
      repositionOnScroll={true}
      panelProps={{ paddingSize: "none" }}
    >
      <EuiListGroup css={styles.panel} maxWidth="100%">
        {[true, false].map((option) => (
          <EuiListGroupItem
            id={option.toString()}
            key={option.toString()}
            iconType={value === option ? "check" : "empty"}
            label={String(option)}
            onClick={() => {
              if (value === option) {
                onValueChange(undefined);
                setValue(undefined);
              } else {
                onValueChange(option);
                setValue(option);
              }
            }}
          />
        ))}
      </EuiListGroup>
    </EuiPopover>
  );
};
